import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import useAxios from 'axios-hooks';
import { renderToString } from 'react-dom/server';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import DOMPurify from 'isomorphic-dompurify';
import { FOS_POLICY_27825} from "../../tools/flags";
import { fetchGeneralSettings, policyFormSelector } from '../../entities/ProjectSlice';
import { useEffect } from 'react';

import EmailTemplate from '../../components/email/EmailTemplate';
import api from '../../entities/api';
import { emailFormSelector, handleOpenEmailForm, handleOpenModelError } from '../../entities/ComponentsSlice';
import { flatsLocalStorageSelector } from '../../entities/FavoriteFlatSlice';
import ButtonBlack from '../../features/button-black/ButtonBlack';
import ButtonClose from '../../features/button-close/ButtonClose';
import InputEmail from '../../features/input-email/InputEmail';
import Portal from '../../shared/portal/Portal';
import style from './ModalEmail.module.scss';

function ModalEmail() {
  const openEmailForm = useSelector(emailFormSelector);
  const dispatch = useDispatch();
  const policyForm = useSelector(policyFormSelector);

  const handleCloseModelEmail = () => {
    dispatch(handleOpenEmailForm(false));
  };

  const schema = yup.object().shape({
    email: yup.string().email('Неверный формат').required('Обязательное поле'),
    ...(!FOS_POLICY_27825 && { agreement: yup.bool().oneOf([true], 'Обязательное поле') }),
    ...(FOS_POLICY_27825 && { agreement: yup.bool(), newsletter_agreement: yup.bool() }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      ...(FOS_POLICY_27825 && { agreement: Boolean(policyForm.caption), newsletter_agreement: false }),
    },
  });

  let apartmentsNumbersString = '';
  let flatsIdsString = '';

  const flatfavorites = useSelector(flatsLocalStorageSelector);

  if (flatfavorites) {
    const localStorageArray = flatfavorites;
    localStorageArray.forEach(item => {
      if (item.apartmentNumber) {
        apartmentsNumbersString += item.apartmentNumber + ', ';
      } else apartmentsNumbersString += item.number + ', ';
      flatsIdsString += item.id + '|';
    });
    apartmentsNumbersString = apartmentsNumbersString.slice(0, -2);
    flatsIdsString = flatsIdsString.slice(0, -1);
  }

  const favoritesMailContent = renderToString(<EmailTemplate ids={flatsIdsString} />);

  const getCookie = name => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const [, emailRequest] = useAxios({ url: `${api.urlPdf}/favorites/send`, method: 'POST' }, { manual: true });

  const onSubmit = data => {
    emailRequest({
      data: {
        ...data,
        'form-name': 'favoritesEmailForm',
        'mail-theme': 'Презентация избранных предложений ЖК MOMENTS',
        'mail-text': favoritesMailContent,
        ids: flatsIdsString,
        cm_data: getCookie('cm_data'),
        ...(FOS_POLICY_27825 && {
          agreement: Boolean(policyForm.caption),
          newsletter_agreement: data.newsletter_agreement,
        }),
      },
    })
      .then(response => {
        window.dataLayer.push({
          event: 'event-to-gtm',
          eventCategory: 'Form',
          eventAction: 'Send',
          eventLabel: 'Отправить презентацию',
        });
        reset();
        handleCloseModelEmail();
      })
      .catch(error => {
        console.log(error.data);
        dispatch(handleOpenModelError(true));
      });
  };

  useEffect(() => {
    if (FOS_POLICY_27825 && !policyForm.caption) {
      dispatch(fetchGeneralSettings());
    }
  }, [policyForm]);

  return (
    <>
      {openEmailForm && (
        <Portal>
          <div className={style.modalContainer}>
            <div className={style.modalBack} />
            <form name='favoritesEmailForm' className={style.modalBox} onSubmit={handleSubmit(onSubmit)}>
              <ButtonClose className={style.modalBtn} handleFuction={handleCloseModelEmail} id='close_black' />
              <div className={style.modalTitle}>Отправить презентацию</div>
              <div className={style.modalText}>
                <InputEmail
                  placeholder='Введите свою электронную почту'
                  label='Email'
                  register={register('email')}
                  errors={Boolean(errors.email)}
                  errorLabel={errors?.email?.message}
                  className={style.modalInput}
                />
              </div>

              {FOS_POLICY_27825 && (
                  <div className={style.formWrapper}>
                    {Boolean(policyForm.caption) && (
                        <div
                            className={style.modalText}
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policyForm.caption) }}
                        />
                    )}
                    {Boolean(policyForm.checkbox) && (
                        <div className={`${style.checkbox} ${style.modalText}`}>
                          <input
                              id='newsletter_agreement'
                              type='checkbox'
                              className={style.checkbox__input}
                              {...register('newsletter_agreement')}
                              data-testid='newsletter_agreement-checkbox'
                          />
                          <label
                              htmlFor='newsletter_agreement'
                              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policyForm.checkbox) }}
                          />
                        </div>
                    )}
                  </div>
              )}
              <ButtonBlack className={style.modalBtnClose} type='submit' text='Отправить' testId='sendPdf' />
            </form>
          </div>
        </Portal>
      )}
    </>
  );
}

export default ModalEmail;
